export default __webpack_public_path__ + "static/media/others.51650f51.svg";